import { BASE_URL, INDIAN_MSME_USER_TOKEN } from "../../utils/Constants";
import { RootState } from "..";
import axios from "axios";
import { ThunkAction } from "redux-thunk";
import CategoryType, {
  GetCategory,
  GetSubCategory,
  GetChildCategory,
} from "../types/categoryType";
import { getCookie } from "../../utils/CookieAction";
import LogoutAction from "./LogoutAction";

interface Action {
  type: string;
  payload?: any;
  message?: string;
}

const CategoryAction = {
  getCategory:
    (data: GetCategory): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const catData: any = await axios.post(
          BASE_URL + "category/get",
          {
            search: data.search,
            limit: data.limit,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
              "Content-Type": "multipart/form-data",
            },
          }
        );

        dispatch({
          type: CategoryType.SET_CATEGORY_LIST,
          payload: catData.data.data.data,
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  getSubCategory:
    (data: GetSubCategory): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        let url: any = "";

        const headers = {
          headers: {
            Authorization: "Bearer " + JSON.parse(token),
            Accept: "application/json",
          },
        };

        if (data.type === "filter") {
          url = axios.post(
            BASE_URL + "sub-category/select",
            {
              cat_id: data.category,
            },
            headers
          );
        } else {
          url = axios.post(
            BASE_URL + "sub-category/get",
            {
              search: data.search,
              limit: data.limit,
            },
            headers
          );
        }

        const catData: any = await url;

        dispatch({
          type: CategoryType.SET_SUB_CATEGORY_LIST,
          payload: catData.data.data,
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  getChildCategory:
    (data: GetChildCategory): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        let url: any = "";

        const headers = {
          headers: {
            Authorization: "Bearer " + JSON.parse(token),
            Accept: "application/json",
          },
        };

        if (data.type === "filter") {
          url = axios.post(
            BASE_URL + "child-category/select",
            {
              sub_cat_id: data.sub_category,
            },
            headers
          );
        } else {
          url = axios.post(
            BASE_URL + "child-category/get",
            {
              search: data.search,
              limit: data.limit,
            },
            headers
          );
        }

        const catData: any = await url;

        dispatch({
          type: CategoryType.SET_CHILD_CATEGORY_LIST,
          payload: catData.data.data,
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },
};

export default CategoryAction;
